import { mergeTemplate } from './base-template';

export const treuhandKmuTemplate = mergeTemplate({
  name: 'Treuhand für KMU',
  icon: '🏢',
  settings: {
    primaryColor: '#1a365d',
    accentColor: '#38a169',
    fontStack: 'instrument',
    stylePreset: 'swiss',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'KMU-Treuhand-Pakete',
      heroSubtitle: 'Fokussiert auf das, was Ihr KMU wirklich braucht',
      packages: [
        { name: 'KMU Basis', price: 'ab CHF 290/Mt.', description: 'Buchhaltung und Lohnabrechnung', features: 'Fibu, Lohnbuchhaltung, MWST-Abrechnung, Jahresabschluss-Vorbereitung', highlighted: false },
        { name: 'KMU Komfort', price: 'ab CHF 590/Mt.', description: 'Alles aus Basis plus Steuerplanung', features: 'Basis + Steuererklärung, Budget, Debitoren-Management, Quartals-Cockpit', highlighted: true },
        { name: 'KMU Premium', price: 'ab CHF 990/Mt.', description: 'Full-Service mit strategischer Beratung', features: 'Komfort + CFO-Sparring, Personaladmin, Versicherungs-Check, Nachfolgeplanung', highlighted: false },
      ],
      ctaTitle: 'Lassen Sie uns über Ihr KMU sprechen',
      ctaText: 'Jedes KMU ist anders. Wir finden das Paket, das zu Ihnen passt.',
      ctaButtonText: 'Unverbindlich anfragen',
    },
    pageMethoden: {
      heroTitle: 'So arbeiten wir mit KMU',
      heroSubtitle: 'Effizient, digital, persönlich',
      introText: 'Unsere Prozesse sind auf die Bedürfnisse von Schweizer KMU optimiert — pragmatisch und ohne unnötige Komplexität.',
      steps: [
        { title: 'Erstgespräch', description: 'Kostenlose Bestandsaufnahme Ihrer aktuellen Situation' },
        { title: 'Setup', description: 'Einrichtung der Tools, Übergabe der Unterlagen, Prozessdefinition' },
        { title: 'Laufende Betreuung', description: 'Monatliche Buchhaltung, Lohn, MWST — termingerecht und zuverlässig' },
        { title: 'Quartals-Review', description: 'Besprechung der Zahlen, Empfehlungen, Anpassungen' },
      ],
      tools: [
        { name: 'Bexio', description: 'Cloud-Buchhaltung und Rechnungsstellung' },
        { name: 'KLARA', description: 'Lohn- und Sozialversicherungsabrechnung' },
        { name: 'DeepBox', description: 'Digitale Belegverarbeitung' },
      ],
      philosophyTitle: 'KMU-Philosophie',
      philosophyText: 'Wir sprechen Ihre Sprache, nicht Fachchinesisch. Klare Prozesse, faire Preise, persönliche Betreuung.',
    },
    pageUeberMich: {
      heroTitle: 'Ihr KMU-Treuhand-Team',
      heroSubtitle: 'Lokal verankert, digital vernetzt',
      introText: 'Wir kennen die Herausforderungen von Schweizer KMU — weil wir selbst eines sind.',
      imageUrl: '',
      timeline: [
        { year: '2010', text: 'Gründung mit Fokus auf KMU-Buchhaltung' },
        { year: '2017', text: 'Umstellung auf Cloud-basierte Prozesse' },
        { year: '2022', text: 'Erweiterung um Lohn- und Personaladmin' },
      ],
      values: [
        { title: 'KMU-Verständnis', description: 'Wir kennen die Realität kleiner und mittlerer Unternehmen' },
        { title: 'Termintreue', description: 'Fristen sind für uns nicht verhandelbar' },
        { title: 'Digitale Effizienz', description: 'Moderne Tools für schnellere, günstigere Prozesse' },
      ],
      certifications: 'Treuhand Suisse, MWST-Spezialist, Bexio Gold Partner',
    },
  },
  components: {
    header: {
      companyName: 'Treuhand Muster AG',
      logoText: 'TM',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Erstgespräch buchen',
    },
    hero: {
      title: 'Treuhand für KMU in Ihrer Region',
      subtitle:
        'Terminsicher, verständlich, digital – damit Sie Zeit fürs Kerngeschäft haben.',
      primaryBtn: 'Kostenloses Erstgespräch',
      secondaryBtn: 'Leistungen',
      imageUrl: '',
    },
    services: {
      title: 'KMU-Leistungen',
      subtitle: 'Fokus auf Alltagstauglichkeit und Terminsicherheit.',
      items: [
        {
          icon: '📊',
          title: 'Fibu & Abschluss',
          text: 'Sauber buchen, abstimmen und abschliessen – ohne Hektik.',
        },
        {
          icon: '🧾',
          title: 'Steuern & MWST',
          text: 'Erklärungen, Abrechnungen, Planung – strukturiert und verständlich.',
        },
        {
          icon: '👥',
          title: 'Lohn',
          text: 'Lohnläufe, Quellensteuer, Sozialversicherungen – terminsicher.',
        },
      ],
    },
    team: {
      title: 'Ihr KMU-Team',
      subtitle: 'Feste Ansprechpartner, die Ihr Geschäft kennen.',
      members: [
        {
          name: 'Daniel Huber',
          role: 'Geschäftsführer & Treuhandexperte',
          image: '',
          bio: 'Spezialisiert auf KMU-Buchhaltung und Steuerplanung. Über 15 Jahre Erfahrung mit Schweizer Kleinunternehmen.',
        },
        {
          name: 'Claudia Schmid',
          role: 'Lohn & Sozialversicherungen',
          image: '',
          bio: 'Verantwortlich für Lohnbuchhaltung, Quellensteuer und die Zusammenarbeit mit den Sozialversicherungen.',
        },
      ],
    },
    testimonials: {
      title: 'Was KMU-Inhaber sagen',
      items: [
        {
          quote: 'Endlich habe ich Ruhe bei den Fristen und weiss genau, wo mein Betrieb finanziell steht.',
          author: 'P. Bühler',
          role: 'Inhaber, Elektroinstallationen',
        },
        {
          quote: 'Die Umstellung auf digitale Buchhaltung war dank dem Team erstaunlich einfach.',
          author: 'S. Ammann',
          role: 'Geschäftsführerin, Kosmetikstudio',
        },
        {
          quote: 'Faire Preise, klare Kommunikation und immer erreichbar. Genau das braucht ein KMU.',
          author: 'M. Roth',
          role: 'Inhaber, Gartenbau GmbH',
        },
        {
          quote: 'Die Quartals-Reviews geben mir einen klaren Überblick — so kann ich bessere Entscheidungen treffen.',
          author: 'K. Fischer',
          role: 'Inhaberin, Textilhandel',
        },
      ],
    },
    faq: {
      title: 'Häufige Fragen',
      subtitle: 'Antworten für KMU-Inhaber.',
      items: [
        {
          question: 'Ab welcher Unternehmensgrösse lohnt sich ein Treuhänder?',
          answer:
            'Bereits ab der Gründung. Schon bei Einzelfirmen spart professionelle Buchhaltung Zeit und vermeidet teure Fehler bei Steuern und MWST.',
        },
        {
          question: 'Können wir unsere bestehende Buchhaltungssoftware behalten?',
          answer:
            'Ja. Wir arbeiten mit allen gängigen Lösungen wie Bexio, KLARA oder Abacus. Falls gewünscht, unterstützen wir auch bei einem Wechsel.',
        },
        {
          question: 'Wie werden die Kosten berechnet?',
          answer:
            'Wir bieten transparente Monatspauschalen je nach Umfang. Im Erstgespräch klären wir Ihre Bedürfnisse und erstellen eine verbindliche Offerte — ohne versteckte Kosten.',
        },
      ],
    },
  },
});
